// This is an example encoding for the Solutons Barcode type:
// @@EMBEDDED@@*Ser*=407002234827|*SKU*=Ecommerce|*Bin*=No Color|*Prc*=0.01|

import * as Sentry from '@sentry/browser'
import { showFailure } from '../../../Toast'

// We’ll need to extract the Ser key as the item sku if it fits this pattern
export const START_OF_SOLUTIONS_BARCODE = '@@EMBEDDED@@'

export function isValidBarcode(barcode) {
  return (
    (barcode.endsWith('\n') || barcode.endsWith('\r') || barcode.endsWith('Enter')) &&
    barcode.replace(/Enter/g, '').trim().length > 0
  )
}

export function isSolutionsBarcode(barcode) {
  return barcode.startsWith(START_OF_SOLUTIONS_BARCODE) && barcode.includes('*Ser*')
}

export function getBarcode(barcode) {
  const scanedPOSBarcode = isSolutionsBarcode(barcode)

  if (!scanedPOSBarcode && !isValidBarcode(barcode)) return false

  if (scanedPOSBarcode) {
    if (!isValidBarcode(barcode)) return false

    const newBarcode = barcode.replace(START_OF_SOLUTIONS_BARCODE, '')

    const parts = newBarcode.split('|')
    const skuPart = parts.find(p => p.startsWith('*Ser*'))

    if (skuPart) {
      const sku = skuPart.split('=')[1]
      return sku
    }

    showFailure(
      'We think this is a Solutions ITW formatted barcode, but we failed to read it. Please reach out to support or try again with a different barcode.'
    )

    Sentry.withScope(scope => {
      scope.setExtra('barcode', barcode)
      Sentry.captureMessage('Failed to read Solutions ITW barcode')
    })

    return false
  }
  return barcode.replace(/Enter/g, '').trim() // removes the \n from the end of the barcode
}

export function trackScannedBarcodeEvent(solutionsBarcode): void {
  const trackingName = 'Manifest Item Added By Scan'
  const trackingData = {
    solutionsBarcode
  }

  analytics.track(trackingName, trackingData)
}

export function trackManifestItemAddedByDecsriptionEvent(solutionsBarcode): void {
  const trackingName = 'Manifest Item Added By Description'
  const trackingData = {
    solutionsBarcode
  }

  analytics.track(trackingName, trackingData)
}
